import { render, staticRenderFns } from "./cost-config-dlg.vue?vue&type=template&id=44204acf&"
import script from "./cost-config-dlg.vue?vue&type=script&lang=js&"
export * from "./cost-config-dlg.vue?vue&type=script&lang=js&"
import style0 from "./cost-config-dlg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports